import { tv } from '@costar-ui/cosmos';
import baseButton from './theme/base-button.esm.js';
import nextButton from './theme/next-button.esm.js';

var base = tv(baseButton);
var next = tv(nextButton);
var buttonStyles = {
  base: base,
  next: next
};

export { buttonStyles };
//# sourceMappingURL=button.styles.esm.js.map
